var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{directives:[{name:"srcAttr",rawName:"v-srcAttr"}],attrs:{"frameborder":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }